import { ContractType } from "domain/contract";
import { useState } from "react";
import * as _ from "lodash";
import ContractSubType from "./contractSubType";
import contractService from "./contractService";
import { PaymentOption } from "domain/paymentOption";
import { DeliveryMethod } from "domain/deliveryMethod";

const getCached = _.memoize(async (contractType: ContractType, customerWillSell: boolean, cropYearId: string, paymentOption: Nullish<PaymentOption>, deliveryMethod: DeliveryMethod) => {
    return await contractService.listContractSubTypes(contractType, customerWillSell, cropYearId, paymentOption, deliveryMethod);
});

export default function useContractSubTypes(contractType: Nullish<ContractType>, customerWillSell: Nullish<boolean>, cropYearId: Nullish<string>, paymentOption: Nullish<PaymentOption>, deliveryMethod: Nullish<DeliveryMethod>): ContractSubType[] {

    const [subTypes, setSubTypes] = useState<ContractSubType[]>(null);

    if (contractType == null) return [];
    if (customerWillSell == null) return [];

    if (subTypes == null) {
        getCached(contractType, customerWillSell, cropYearId, paymentOption, deliveryMethod).then(setSubTypes);
        return [];
    }

    return subTypes;
}